import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'daysOpen'
})
export class DaysOpenPipe implements PipeTransform {
  transform(createdOn: any, statusReason: string, closedOn?: any): number | null {
    if (!createdOn) return null;
    const start = new Date(createdOn);
    const end = (statusReason === 'Closed' && closedOn) ? new Date(closedOn) : new Date();
    return Math.max(0, Math.ceil((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)));
  }
}
